<template>
  <div>
    <the-side-bar
      @subMenuClosed="closeSubMenu"
      @showSubMenuFunction="showSubMenuFunction"
      :notMobile="notMobile"
      :showSubMenu="showSubMenu"
      class="sidebar"
    ></the-side-bar>
    <div class="layout p-0 overflow-auto" :style="`width: calc(100% - ${this.sidebar_width})`">
      <div ref="header" class="d-flex">
        <the-header
          :notMobile="notMobile"
          class="header"
          :style="`width: calc(100% - ${this.sidebar_width})`"
        ></the-header>
      </div>
      <div id="main-view" class="content">
        <base-spinner v-if="loading"></base-spinner>
        <router-view v-else v-slot="slotProps">
          <transition name="route" mode="out-in">
            <component :is="slotProps.Component"></component>
          </transition>
        </router-view>
      </div>
    </div>

    <ReportedIssueModal
      v-for="(item, index) in reported_issues"
      :key="index"
      @refreshData="() => {}"
      :id="item?._id"
      :data="item"
    />
  </div>
</template>

<script>
import { socket, state } from '@/socket'
import TheHeader from './TheHeader.vue'
import TheSideBar from './TheSideBar.vue'
import ReportedIssueModal from '@/components/ReportedIssues/modal.vue'
import ReportService from '@/services/report.service'

export default {
  data() {
    return {
      height: '',
      sidebar_width: null,
      loading: false,
      error: null,
      notMobile: false,
      reported_issues: [],
      showToggleSubMenu: false,
      showSubMenu: true,
    }
  },
  components: { TheHeader, TheSideBar, ReportedIssueModal },
  mounted() {
    setTimeout(() => {
      this.sidebar_width = document.getElementsByClassName('sidebar')[0]?.clientWidth + 'px'
    }, 0)
    this.height = this.$refs.header.clientHeight
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
  },
  beforeMount() {
    window.removeEventListener('resize', this.checkWindowSize)
  },
  async created() {
    this.$watch(
      () => window.innerWidth,
      (newWidth) => {
        this.notMobile = newWidth >= 700
      }
    )
    if (this.$store.getters['auth/authenticated']) {
      try {
        this.loading = true
        socket.connect()
        await this.$store.dispatch('enums/GET_USER_INFO', { forceFetch: true })
        if (
          this.$store.getters['enums/user_info']?.permissions.includes('viewClient') &&
          this.$store.getters['enums/user_info']?.groups.includes('clients')
        )
          await this.$store.dispatch('enums/GET_CLIENT_INFO') // always should be at the end
        this.loading = false

        // Getting assigned reports to show modal
        const assigned_reports = await ReportService.search({
          assignedTo: this.$store.getters['enums/user_info'].userID,
          isResolved: false,
          driver: 'exists:true',
          select:
            '_id,driver.name,driver.arabicName,trip._id,reason,comments,isResolved,assignedTo,actionTaken',
        })
        if (assigned_reports.items.length) {
          for (let i = 0; i < assigned_reports.items.length; i++) {
            const val = assigned_reports.items[i]
            if (
              val &&
              this.$store.getters['enums/user_info'].roles.includes('Operator') &&
              !this.reported_issues?.find((each) => each._id === val?._id)
            ) {
              this.reported_issues.push(val)
              setTimeout(() => {
                this.$bvModal.show(`reported-issue-modal-${val?._id}`)
              }, 100)
            }
          }
        }

        // Getting un-assigned reports to show modal
        const un_assigned_reports = await ReportService.get('un-assigned-reports', {
          driver: 'exists:true',
          select:
            '_id,driver.name,driver.arabicName,trip._id,reason,comments,isResolved,assignedTo,actionTaken',
        })
        if (un_assigned_reports.items.length) {
          for (let i = 0; i < un_assigned_reports.items.length; i++) {
            const val = un_assigned_reports.items[i]
            if (
              val &&
              this.$store.getters['enums/user_info'].roles.includes('Operator') &&
              !this.reported_issues?.find((each) => each._id === val?._id)
            ) {
              this.reported_issues.push(val)
              setTimeout(() => {
                this.$bvModal.show(`reported-issue-modal-${val?._id}`)
              }, 100)
            }
          }
        }
      } catch (error) {
        this.error = error.reason
        this.loading = false
      }
    }
  },
  computed: {
    reported_issue_update() {
      return state.reported_issue_update
    },
    dismiss_report_issue_update() {
      return state.dismiss_report_issue_update
    },
    auto_assign_trip() {
      return state.auto_assign_trip
    },
    assignVehicleRoute() {
      return state.assign_vehicle_route
    },
    generateTripSuccess() {
      return state.generateTripSuccess
    },
    generateTripFailed() {
      return state.generateTripFailed
    },
  },
  watch: {
    reported_issue_update(val) {
      if (
        val &&
        (this.$store.getters['enums/user_info'].roles?.includes('Operator') ||
          this.$store.getters['enums/user_info'].roles?.includes('operator')) &&
        (!val?.report?.assignedTo?._id ||
          val?.report?.assignedTo?._id === this.$store.getters['enums/user_info'].userID)
      ) {
        if (!this.reported_issues?.find((each) => each._id === val?.report?._id))
          this.reported_issues.push(val?.report)
        setTimeout(() => {
          this.$bvModal.show(`reported-issue-modal-${val?.report?._id}`)
        }, 100)
      }
    },
    dismiss_report_issue_update(val) {
      if (
        val?.report?._id &&
        (this.$store.getters['enums/user_info'].roles?.includes('Operator') ||
          this.$store.getters['enums/user_info'].roles?.includes('operator'))
      ) {
        this.$bvModal.hide(`reported-issue-modal-${val?.report?._id}`)
      }
    },
    auto_assign_trip(val) {
      if (val && val?.userID === this.$store.getters['enums/user_info'].userID) {
        const total = val?.total
        const successCount = val?.successCount
        const failedCount = val?.failedCount
        this.$store.dispatch('enums/SHOW_TOASTER_POP', {
          message: this.$t('auto-assign-success', { total, successCount, failedCount }),
          variant: 'success',
          title: 'success',
          duration: 0,
          noCloseButton: false,
          noAutoHide: true,
        })
      }
    },
    assignVehicleRoute(val) {
      if (!val) return
      const failedTrips = val?.failedTrips.length ? val?.failedTrips?.map((item) => item.tripId) : 0
      const successCount = val?.successCount
      const failedCount = val?.failedCount
      const routeId = val?.routeId
      this.$store.dispatch('enums/SHOW_TOASTER_POP', {
        message: this.$t('assign-vehicle-route-success', {
          routeId,
          successCount,
          failedCount,
          failedTrips,
        }),
        variant: 'success',
        title: this.$t('success'),
        duration: 0,
        noCloseButton: false,
        noAutoHide: true,
      })
    },
    generateTripSuccess(val) {
      if (!val) return
      const contractId = val?.contractId
      this.$store.dispatch('enums/SHOW_TOASTER_POP', {
        message: this.$t('generate-trips-contract-success', { contractId }),
        variant: 'success',
        title: this.$t('success'),
        duration: 0,
        noCloseButton: false,
        noAutoHide: true,
      })
    },
    generateTripFailed(val) {
      if (!val) return
      const contractId = val?.contractId
      const reason = val?.error
      this.$store.dispatch('enums/SHOW_TOASTER_POP', {
        message: this.$t('generate-trips-contract-failed', { contractId, reason }),
        variant: 'danger',
        title: this.$t('error'),
        duration: 0,
        noCloseButton: false,
        noAutoHide: true,
      })
    },
    $route() {
      this.showSubMenu = true
      this.showToggleSubMenu = false
      this.toggleSubMenu()
    },
  },
  methods: {
    checkWindowSize() {
      this.notMobile = window.innerWidth >= 700
      this.sidebar_width = document.getElementsByClassName('sidebar')[0]?.clientWidth + 'px'
    },
    toggleSubMenu() {
      setTimeout(() => {
        this.sidebar_width = document.getElementsByClassName('sidebar')[0]?.clientWidth + 'px'
      }, 0)
    },
    closeSubMenu() {
      this.showToggleSubMenu = true
      this.showSubMenu = false
      this.toggleSubMenu()
    },
    showSubMenuFunction() {
      this.showToggleSubMenu = false
      this.showSubMenu = true
      this.toggleSubMenu()
    },
  },
}
</script>

<style lang="scss" scoped>
.content {
  background: var(--color-21);
  padding: 2rem;
  padding-top: 7rem;
  min-height: 100vh;
}
.sidebar {
  max-width: 240;
  float: left;
  position: fixed;
  height: 100vh;
  z-index: 1040;
  inset-inline-start: 0;
  top: 0;
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
.sidebar-scrollbar {
  width: 5px;
  background-color: var(--color-21);
}

.sidebar-scrollbar-thumb {
  background-color: var(--color-33);
  border-radius: 5px;
}
.layout {
  display: inline-block;
  position: absolute;
  inset-inline-end: 0;

  .show-toggle-sub-menu-icon {
    padding-block: 20px;
    padding-inline: 5px;
    z-index: 23;
  }
}
.header {
  padding-block: 1rem;

  min-height: 65px;
  padding-inline-start: 30px;
  padding-inline-end: 23px;
  position: fixed;

  z-index: 22;
  background: var(--color-01);
  border-bottom: 1px solid var(--color-101);
  border-inline-start: 1px solid var(--color-101);
}
</style>
